'use strict';

const OVERRIDES_STORAGE_KEY = 'rp:cache-ttl-overrides';

/** LocalStorage key for cached manual location (header + PDP modal). */
const LOCATION_LOCAL_STORAGE_KEY = 'rp:location:v1';

/** @type {Readonly<Record<string, number>>} */
const DEFAULT_TTL_SECONDS = Object.freeze({
	cart: 600, // 10 minutes
	csrf: 600, // 10 minutes
	garage: 1800, // 30 minutes
	location: 600, // 10 minutes (manual ZIP cache, see location-modal-update)
	profile: 600, // 10 minutes
	supplier: 600, // 10 minutes
});

/**
 * @returns {Record<string, number>}
 */
function getOverrides() {
	try {
		if (globalThis.localStorage === undefined || !globalThis.localStorage) {
			return {};
		}
		const raw = globalThis.localStorage.getItem(OVERRIDES_STORAGE_KEY);
		if (!raw) {
			return {};
		}
		const parsed = JSON.parse(raw);
		return typeof parsed === 'object' && parsed !== null ? parsed : {};
	} catch {
		return {};
	}
}

/**
 * @param {Record<string, number>} overrides
 */
function setOverrides(overrides) {
	try {
		if (globalThis.localStorage === undefined || !globalThis.localStorage) {
			return;
		}
		globalThis.localStorage.setItem(OVERRIDES_STORAGE_KEY, JSON.stringify(overrides));
	} catch {
		// no-op
	}
}

/**
 * @param {string} name 'cart' | 'csrf' | 'garage' | 'location' | 'profile' | 'supplier'
 * @returns {number} TTL in seconds
 */
function getTtlFor(name) {
	const overrides = getOverrides();
	if (typeof overrides[name] === 'number' && overrides[name] >= 0) {
		return overrides[name];
	}
	const defaultTtl = DEFAULT_TTL_SECONDS[name];
	return typeof defaultTtl === 'number' ? defaultTtl : 600;
}

/**
 * @param {string} name 'cart' | 'csrf' | 'garage' | 'location' | 'profile' | 'supplier'
 * @param {number} ttlSeconds TTL in seconds
 */
function setTtlFor(name, ttlSeconds) {
	if (!Number.isInteger(ttlSeconds) || ttlSeconds < 0) {
		throw new Error('TTL must be a positive integer or 0');
	}

	const overrides = getOverrides();
	const next = { ...overrides };
	next[name] = ttlSeconds;

	try {
		if (globalThis.localStorage === undefined || !globalThis.localStorage) {
			return;
		}
		globalThis.localStorage.clear();
		if (Object.keys(next).length > 0) {
			setOverrides(next);
		}
		globalThis.location.reload();
	} catch {
		// no-op
	}
}

module.exports = {
	DEFAULT_TTL_SECONDS,
	getOverrides,
	getTtlFor,
	LOCATION_LOCAL_STORAGE_KEY,
	setTtlFor,
};
